import { render, staticRenderFns } from "./Camere.vue?vue&type=template&id=6e35605e&scoped=true&"
import script from "./Camere.vue?vue&type=script&lang=js&"
export * from "./Camere.vue?vue&type=script&lang=js&"
import style0 from "./Camere.vue?vue&type=style&index=0&id=6e35605e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35605e",
  null
  
)

export default component.exports